import React from 'react';
import { Button } from 'reactstrap';

const ButtonComponent = ({
  block,
  isLoading,
  type,
  children,
  size,
  className,
  color
}) => {
  return (
    <Button
      block={block}
      type={type}
      size={size}
      className={className}
      color={color}>
      {isLoading && (
        <span
          className="btn-wrapper--icon spinner-grow spinner-grow-sm"
          role="status"
          aria-hidden="true"></span>
      )}
      <span className="btn-wrapper--label">{children}</span>
    </Button>
  );
};

export default ButtonComponent;
